module.exports = __webpack_public_path__ + "static/media/1POLICY20.51f4c228.jpg";